import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(detectTransitionsRequiringBrazeEvents),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(brazeSagas);

import { select, takeEvery } from 'redux-saga/effects';
import { progressModel } from '@rosetta/gaia-progress';
import { COURSE_PROGRESS_UPDATED } from './braze-reducer';
import { brazeHelper } from '../brazeHelper';
import { amplitudeHelper } from '../amplitudeHelper';
import { sequenceSelectors } from '../../sequence/redux/sequence-reducer';
import { courseSelectors } from '../../course/redux/course-reducer';

// As new Progress data is accumulated, Braze events should be fired at key thresholds.
// Detect these thresholds and fire the corresponding Braze events here.
function detectTransitionsRequiringBrazeEvents(_ref) {
  var _ref$payload = _ref.payload,
      progressMessage = _ref$payload.progressMessage,
      progressBefore = _ref$payload.progressBefore,
      progressAfter = _ref$payload.progressAfter,
      currentSequence = _ref$payload.currentSequence;

  var courseInfo, afterProgressInfo, beforeProgressInfo, shortPercent, _amplitudeHelper$send, afterSequenceProgress, afterActivityProgress, activityAttempt, _currentSequence, currentActivity, isLastStep, activityScore, activityComplete, currentStep, stepIsScorable, stepProgress, stepAttempt, _amplitudeHelper$send2;

  return _regeneratorRuntime.wrap(function detectTransitionsRequiringBrazeEvents$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(courseSelectors.getAssignedCourse, progressMessage.courseId);

        case 2:
          courseInfo = _context.sent;
          afterProgressInfo = progressModel.getCourseProgressInfo(progressAfter);
          beforeProgressInfo = progressModel.getCourseProgressInfo(progressBefore);

          // check for COURSE_STARTED

          if (!progressBefore.hasOwnProperty('percentComplete') && progressAfter.hasOwnProperty('percentComplete')) {
            brazeHelper.logBrazeEvent(brazeHelper.EVENT_STARTED_COURSE, {
              courseId: progressMessage.courseId,
              courseName: courseInfo.title
            });
          }

          // check for COURSE_COMPLETED
          if (afterProgressInfo.isCourseCompleted && !beforeProgressInfo.isCourseCompleted) {
            brazeHelper.logBrazeEvent(brazeHelper.EVENT_COMPLETED_COURSE, {
              courseId: progressMessage.courseId,
              courseName: courseInfo.title
            });
          }

          // braze always wants the percent complete, if it has changed
          if (progressBefore.percentComplete !== progressAfter.percentComplete) {
            shortPercent = Math.round(progressAfter.percentComplete * 1000) / 10;

            brazeHelper.logBrazeEvent(brazeHelper.EVENT_PERCENTAGE_COMPLETED_COURSE, {
              courseId: progressMessage.courseId,
              percentage: shortPercent
            });
          }

          // check for ACTIVITY_SKIPPED

          if (!progressMessage.skip) {
            _context.next = 12;
            break;
          }

          amplitudeHelper.sendAmplitudeEvent(amplitudeHelper.analyticEventNames.ACTIVITY_SKIPPED, (_amplitudeHelper$send = {}, _amplitudeHelper$send[amplitudeHelper.analyticEventPropNames.courseId] = progressMessage.courseId, _amplitudeHelper$send[amplitudeHelper.analyticEventPropNames.sequenceId] = progressMessage.sequenceId, _amplitudeHelper$send[amplitudeHelper.analyticEventPropNames.sequenceVersion] = progressMessage.version, _amplitudeHelper$send[amplitudeHelper.analyticEventPropNames.activityId] = progressMessage.activityId, _amplitudeHelper$send));
          _context.next = 25;
          break;

        case 12:
          // check for ACTIVITY_COMPLETED
          afterSequenceProgress = progressModel.getSequenceProgress(progressAfter, progressMessage.sequenceId);
          afterActivityProgress = afterSequenceProgress.activities.find(function (act) {
            return act.activityId === progressMessage.activityId;
          });
          activityAttempt = afterActivityProgress.attempts.find(function (attempt) {
            return attempt.activityAttemptId === progressMessage.activityAttemptId;
          });

          if (!(activityAttempt && activityAttempt.percentComplete === 1)) {
            _context.next = 25;
            break;
          }

          _context.next = 18;
          return select(sequenceSelectors.getSequence);

        case 18:
          _currentSequence = _context.sent;
          currentActivity = _currentSequence.activities.find(function (act) {
            return act.activityId === progressMessage.activityId;
          });
          isLastStep = currentActivity.steps[currentActivity.steps.length - 1].activityStepId === progressMessage.activityStepId;
          // note activity score here so we can adjust it if this is the last step of an unscored activity

          activityScore = activityAttempt.latestGrade;
          activityComplete = isLastStep;

          if (isLastStep) {
            // check to make sure this is not the first failed attempt (on the last step in the activity)
            currentStep = currentActivity.steps[currentActivity.steps.length - 1];
            stepIsScorable = currentStep.correct && currentStep.correct.length > 0;

            if (stepIsScorable) {
              stepProgress = activityAttempt.steps.find(function (step) {
                return step.activityStepId === progressMessage.activityStepId;
              });
              stepAttempt = stepProgress.attempts.find(function (attempt) {
                return attempt.activityStepAttemptId === progressMessage.activityStepAttemptId;
              });
              // did they answer this step incorrectly?

              if (stepAttempt.score !== 1) {
                // if they have made two attempts at the step then
                //  they have actually finished the activity and got it wrong
                activityComplete = stepProgress.attempts.length === 2;
              }
            } else {
              // non-scored activities have null latestGrade, report 1 for their score
              if (activityScore === null) {
                activityScore = 1;
              }
            }
          }
          if (activityComplete) {
            amplitudeHelper.sendAmplitudeEvent(amplitudeHelper.analyticEventNames.ACTIVITY_COMPLETED, (_amplitudeHelper$send2 = {}, _amplitudeHelper$send2[amplitudeHelper.analyticEventPropNames.courseId] = progressMessage.courseId, _amplitudeHelper$send2[amplitudeHelper.analyticEventPropNames.sequenceId] = progressMessage.sequenceId, _amplitudeHelper$send2[amplitudeHelper.analyticEventPropNames.sequenceVersion] = progressMessage.version, _amplitudeHelper$send2[amplitudeHelper.analyticEventPropNames.activityId] = progressMessage.activityId, _amplitudeHelper$send2[amplitudeHelper.analyticEventPropNames.activityScore] = activityScore, _amplitudeHelper$send2[amplitudeHelper.analyticEventPropNames.timeSpent] = activityAttempt.durationMs, _amplitudeHelper$send2));
          }

        case 25:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

export function brazeSagas() {
  return _regeneratorRuntime.wrap(function brazeSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(COURSE_PROGRESS_UPDATED, detectTransitionsRequiringBrazeEvents);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}